import { AddressFormFieldNames } from 'shared/enums/addressFormFieldNames';
import * as Yup from 'yup';
import { ValidationRules } from 'helpers/createFormConfig';

/**
 * Champ adresse sans contrainte Google : utilisé pour les adresses qui ne sont
 * PAS des personnes (biens immobiliers, contacts d'établissement) — le place_id
 * n'y est volontairement pas exigé.
 */
export const addressFieldWithoutPlaceId = Yup.string()
  .trim()
  .required('Ce champ est requis')
  .min(2, 'Ce champ doit contenir au moins 2 caractères');

export const addressValidationRules: ValidationRules<AddressFormFieldNames> = {
  // L'adresse doit être choisie dans l'autocomplete Google : on exige le place_id
  // (sinon le back renvoie un 400). Le test porte sur le champ visible pour que
  // l'erreur s'affiche bien en rouge sous l'input adresse.
  [AddressFormFieldNames.Address]: addressFieldWithoutPlaceId.test(
    'google-place-selected',
    'Veuillez sélectionner une adresse parmi les suggestions proposées',
    function () {
      const { googlePlaceId } = this.parent;
      return !!googlePlaceId;
    }
  ),

  [AddressFormFieldNames.City]: Yup.string()
    .trim()
    .required('Ce champ est requis')
    .min(2, 'Ce champ doit contenir au moins 2 caractères'),

  [AddressFormFieldNames.AdditionalAddress]: Yup.string().trim().nullable(),

  [AddressFormFieldNames.GooglePlaceId]: Yup.string().trim().nullable(),

  [AddressFormFieldNames.PostalCode]: Yup.string()
    .trim()
    .required('Le code postal est requis')
    .matches(/^\d{4,6}$/, 'Le code postal doit contenir entre 4 et 6 chiffres'),

  [AddressFormFieldNames.Country]: Yup.string()
    .trim()
    .required('Le pays est requis')
    .matches(/^[A-Z]{2}$/, 'Le pays doit être un code ISO à 2 lettres'),

  [AddressFormFieldNames.Latitude]: Yup.number()
    .nullable()
    .min(-90, 'La latitude doit être entre -90 et 90')
    .max(90, 'La latitude doit être entre -90 et 90'),

  [AddressFormFieldNames.Longitude]: Yup.number()
    .nullable()
    .min(-180, 'La longitude doit être entre -180 et 180')
    .max(180, 'La longitude doit être entre -180 et 180')
};
